import { recomputeMarkerStateEvent } from "@/services/map-management/icon-manager/marker-layer";
import { useStore } from "@/store/store";

import type MapEntityBase from "./map-entity-base";

interface PositionedDeviceModel {
    lat?: number;
    long?: number;
    onChange?: {
        addListener: (hook: () => void, uid?: string) => string;
    };
}

interface PositionedMapEntity extends MapEntityBase {
    lat: number;
    long: number;
    model: PositionedDeviceModel;
}

/**
 * Copies device model coordinates onto the map entity and refreshes marker placement.
 */
export const syncMapEntityPositionFromModel = (mapEntity: PositionedMapEntity) => {
    const { lat, long } = mapEntity.model;
    if (mapEntity.lat === lat && mapEntity.long === long) {
        return;
    }

    // Skips the entity currently being repositioned so we don't fight it
    const { isRepositioningDevice, selectedMapEntity } = useStore.getState();
    if (isRepositioningDevice && selectedMapEntity === mapEntity) {
        return;
    }

    mapEntity.lat = lat ?? mapEntity.lat;
    mapEntity.long = long ?? mapEntity.long;
    recomputeMarkerStateEvent.trigger(mapEntity);
};

/**
 * Keeps map marker position in sync whenever the underlying device model changes.
 */
export const registerMapEntityPositionSync = (mapEntity: PositionedMapEntity) => {
    mapEntity.model.onChange?.addListener(() => {
        syncMapEntityPositionFromModel(mapEntity);
    }, mapEntity.uid);
};
